var qty = 2
var prices = [146,150]
var prices_init = [146,150]
var b_price, a_price

function onDateClear(){
	fdate=""
	$('#q-date').val(fdate)
	$('#q-dateh').val(fdate)
}

function onDateSelect(){
	let dv = $('#req-date').val();
    dv = dv.replace(/-|\./g, '/');
	var now = new Date(dv);
	$('#req-dateh').val($('#req-date').val())
	now.setDate(now.getDate()-63);
	var day = now.getDate()<10?'0'+now.getDate():now.getDate();
	var month = (now.getMonth()+1)<10?'0'+(now.getMonth()+1):now.getMonth()+1
	var year = now.getFullYear()
	var fdate = month+'.'+ day +'.'+ year

	$('#q-date').val(fdate)
	$('#q-dateh').val(fdate)
}

function onCurrencyChange(){

  if(prices == prices_gb){
   	prices = prices_eu
  }else{
  	prices = prices_gb
  }
  calculatePrice()
}

function calculatePrice(){

    qty=$('#q-qty').val()

   var h_price = curr_hood=="h-yes"?6:0;

   prices_init
  
   prices[0] = prices_init[0] + h_price;
   prices[1] = prices_init[1] + h_price;
	
	if(qty<2){
		b_price = prices[0] + prices[0]*50/100
		a_price = prices[1] + prices[1]*50/100
	}
  
    if(qty>=10 && qty<20){
		b_price = prices[0] - prices[0]*10/100
		a_price = prices[1] - prices[1]*10/100
	}
    
    if(qty>=2 && qty<10){
		b_price = prices[0]
		a_price = prices[1]
	}
	
	if(qty>=20 && qty<30){
		b_price = prices[0] - prices[0]*20/100
		a_price = prices[1] - prices[1]*20/100
	}
	
	if(qty>=30){
		b_price = prices[0] - prices[0]*30/100
		a_price = prices[1] - prices[1]*30/100
	}
	
	$('#adult-price').text('$'+a_price.toFixed(2))
	$('#boy-price').text('$'+b_price.toFixed(2))
	
}

function initQuoteForm(){

    $('#q-qty').val(qty)
	setInterval(function(){$('#q-url').val(getDesignUrl())}, 100);
	
	calculatePrice()
	
	
	$('#q-qty').numeric();
	
	$('#q-qty').on('input',function(){
		if($('#q-qty').val()<10){
			//$('#q-qty').val(10)
		}
		qty = $('#q-qty').val()
	})
	
	$('#q-qty').focusin(function(){
		$(this).select();
	})
	
	$('#q-qty').focusout(function(){
		if($(this).val()=='' ||$(this).val()<10 ){$(this).val(2)}
	})
	
	
	
	$('.qtybtn').bind('click',setQty)
	
	$('.rfield').each(function(index, element){
		$(element).attr('iname',$(element).attr('value'))
		$(element).bind('focusin',
		function clearField(){
			if($(element).val()== 'TELEPHONE' || $(element).val()=='NAME' || $(element).val()=='EMAIL' || $(element).val()=='REQUIRED !' || $(element).val()=='INVALID EMAIL !'|| $(element).val()=='TEAM NAME' ){
			$(element).val('')
			}
		})
		
		$(element).bind('focusout',
		function clearField(){
			if($(element).val()==''){
			  $(element).val($(element).attr('iname'))
			}
		})
	})
	
	var bar = $('.bar');
	var percent = $('.percent');
  
  $('#get-quote').submit(function( event ) {
    event.preventDefault();
  });

  $('#qtbtn').bind('click',function(){
  
  		   $('#svg-file').val(encodeURIComponent($('#design').html()))
			$('#q-url').val(getDesignUrl())
			if(validateForm()!=4){
				return false
			}
			else
            {
				$('#get-quote').css('opacity',0.7)
                $('#get-quote-f').css('opacity',0.7)
                $('#qtbtn').val('SENDING');
                setTimeout(function() {
                  $('#qtbtn').val('SENT');
                  $('#qtbtn').parent().find('.share-new-btn-icon').addClass('sent');
                  $('#get-quote').submit();
                }, 2000)
              //$('#quotestat').show()  
			}
  })
	
	
	/************ validate form ***************/
	
	function validateForm(){
      
		vcount = 0
        
		if($('#q-name').val()!='' && $('#q-name').val()!='NAME' && $('#q-name').val()!='REQUIRED !'){
			vcount++
		}else{
			$('#q-name').val('REQUIRED !')
		}
      
        if($('#q-phone').val()!='' && $('#q-phone').val()!='TELEPHONE' && $('#q-phone').val()!='REQUIRED !'){
			vcount++
		}else{
			$('#q-phone').val('REQUIRED !')
		}
		
		if($('#q-mail').val()!='' && $('#q-mail').val()!='NAME' && $('#q-mail').val()!='REQUIRED !'){
			if(isValidEmailAddress($('#q-mail').val())){
				vcount++
			}else{
				$('#q-mail').val('INVALID EMAIL !')
			}
		}else{
			$('#q-mail').val('REQUIRED !')
		}


        if($('.state-selected').text()=="STATE" || $('.state-selected').text()=="REQUIRED") {
          $('.state-selected').text('REQUIRED');
        } else {
          vcount++
        }
		
		
		return vcount;
	}
	
function isValidEmailAddress(emailAddress) {
                                   $('#q-url').val(getDesignUrl())
		var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	};
}

function setQty(){
	if($(this).attr('id')=='qplus'){
		qty++
		if(qty>999){
			qty=999
		}
	}else{
		qty--
		if(qty<1){
			qty=1
		}
	}
	if(qty<1){
			qty=1
	}
	$('#q-qty').val(qty)
	calculatePrice()	
}

/********** convert xml to string ***************/
function xmlToString(xmlData) { 

    var xmlString;
    //IE
    if (window.ActiveXObject){
        xmlString = xmlData.xml;
    }
    // code for Mozilla, Firefox, Opera, etc.
    else{
        xmlString = (new XMLSerializer()).serializeToString(xmlData);
    }
    return xmlString;
} 

//////////////////////////////////////
//// US sales email functionality ////
//////////////////////////////////////

let us_sales = [
	{
		"name": 	"SALES TURN-GYMNASTICS",
		"email": 	"sales@turn-gymnastics.com",
		"state": 	["International"]
	},
	{
		"name": 	"Lauren Stevens",
		"email": 	"lstevens@ozoneleos.com",
		"state": 	["California","Nevada","Utah","Colardo","Arizona","Oklahoma"]
	},
	{
		"name": 	"London Hovis",
		"email": 	"london@ozoneleos.com",
		"state": 	["Tennessee","Kansas","New Mexico","Texas"]
	},
	{
		"name": 	"Kytra Hunter",
		"email": 	"khunter@ozoneleos.com",
		"state": 	["Louisiana","Mississippi","Alabama","Georgia","Florida"]
	},
	{
		"name": 	"Angie Stott",
		"email": 	"astott@ozoneleos.com",
		"state": 	["Virgina","North Carolina","South Carolina","New Jersey"]
	},
	{
		"name": 	"Lea Brown",
		"email": 	"lbrown@ozoneleos.com",
		"state": 	["Tennessee"]
	},
	{
		"name": 	"Leane Reynolds",
		"email": 	"lreynolds@ozoneleos.com",
		"state": 	["New York","Vermont","New Hampshire","Maine","Nebraska"]
	},
	{
		"name": 	"Whitnee Johnson",
		"email": 	"wjohnson@ozoneleos.com",
		"state": 	["Iowa","Missouri","Kentucky","Ohio","West Virgina","Pennsylvania","Maryland","Connecticut","Massachusetts"]
	},
	{
		"name": 	"Olivia Jones",
		"email": 	"ojones@ozoneleos.com",
		"state": 	["Idaho","Montana","Wyoming","North Dakota","South Dakota","Minnesota","Wisconsin","Illinois","Michigan","Indiana","Arkansas"]
	},
	{
		"name": 	"Makenzie Wilson",
		"email": 	"Makenzie@ozoneleos.com",
		"state": 	["Alaska","Hawaii","Oregon","Washington"]
	}
]

let master_mail = "rebecca@ozoneleos.com"

// get US states 
let us_states = us_sales.map(function(e,i) {return e.state}).join(',').split(',').sort();

// move international to beginning of the list
us_states.unshift('International');
// remove duplicates if exists
us_states = us_states.filter(function(e, i) {return us_states.indexOf(e) == i});

function getSalesRepEmail(state) {
  let email;
  email = us_sales.filter(function(e, i) {
    return e.state.indexOf(state)!=-1
  }).map(function(e) {return e.email})
  return email + ',rebecca@ozoneleos.com';
}

$(document).ready(function() {
  
  let state_holder = $('#state-select');

  // add combobox 
  let selected_holder = $('<div class="state-selected">STATE</div>')
  
  $(selected_holder).appendTo(state_holder)
  
  // add list holder
  var list_holder = $('<div class="state-list"></div>')
  $(list_holder).appendTo(state_holder)

  $(selected_holder).bind('click', showStateCombo)
  $(document).bind('mouseup', hideStateCombo)

  $(us_states).each(function(index, element) {

      let combo_option = $('<div class="state-option">' + element + '</div>')
      $(combo_option).appendTo($(list_holder))
      
      if(isTouchDevice()==false){
          $(combo_option).bind('mouseup',onStateItemSelect)
      }else{
         $(combo_option).bind('touchend',onStateItemSelect)
      }
  });
})

function showStateCombo() {
    $(".state-list").toggle();
}

function hideStateCombo() {
    $(".state-list").hide();
}

function isTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}

function onStateItemSelect(){
    $('.state-selected').text($(this).text().toUpperCase());
	let sales_state = $(this).text();
    $('#adminemail').val(sales_state);
    //$('#adminemail').val(getSalesRepEmail(sales_state));
}

